<template>
    <div class="mm-section__faq-topic"
        :class="{ 'mm-section__faq-topic--full-width': fullWidth }">
        <div class="mm-section__faq-topic-header">
            <span class="headline headline--third headline--colored">
                {{headingText}}
            </span>
        </div>
        <ul class="list--classic mm-section__faq-topic-questions">
            <li v-for="link in links" :key="link.id">
                <router-link :to="localeRoute({name: 'help_id', params: { id: link.seo_id}})">
                    {{link.title}}
                </router-link>
            </li>
        </ul>
        <router-link v-if="showMoreButton === true" :to="returnLink"
            class="button button--wider-border button--small-text transparent--button button--l button--uppercase button--float-left">
            {{returnText}}
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        headingText: {
            type: String,
            required: true
        },
        returnText: {
            type: String
        },
        returnLink: {
            type: String
        },
        links: {
            type: Array,
            required: true
        },
        showMoreButton: {
            type: Boolean,
            default: true
        },
        fullWidth: {
            type: Boolean,
            default: false
        }
    }
}
</script>